import { FormsContext } from '@ngt/forms';
import { JsonServiceClient } from '@servicestack/client';
import { useCallback, useContext, useMemo } from 'react';
import useSWR, { mutate, SWRConfiguration } from 'swr';
import { PatientGetCollectionBySearch, PatientSearchResponse } from '../apis/dtos';
import { BoundMutator } from '../utilities/BoundMutator';


// @ts-ignore: declared but not used 'url'
const fetcher = async (
    url: string,
    client: JsonServiceClient,
    mrn?: string,
    firstName?: string,
    lastName?: string,
    page?: number,
    rows?: number,
) => {
    return await client?.get(new PatientGetCollectionBySearch({
        mrn,
        firstName,
        lastName,
        page,
        pageSize: rows
    }));
}

const urlKey = '/api/patients';

const usePatients = (
    mrn?: string,
    firstName?: string,
    lastName?: string,
    page?: number,
    rows?: number,
    configuration?: SWRConfiguration<PatientSearchResponse, PatientSearchResponse>
) => {
    const { serviceStackClient: client } = useContext(FormsContext);

    const cacheKey = useMemo(() => {
        return [urlKey, client, mrn, firstName, lastName, page, rows]
    }, [client, mrn, firstName, lastName, page, rows])

    const { data, error } = useSWR<PatientSearchResponse, PatientSearchResponse>(cacheKey, fetcher, configuration);

    const boundMutate: BoundMutator<PatientSearchResponse> = useCallback((data, shouldRevalidate) => {
        return mutate(cacheKey, data, shouldRevalidate);
    }, [cacheKey]);

    return {
        data: data?.data,
        total: data?.count,
        error: error?.responseStatus,
        loading: data === undefined && error === undefined,
        mutate: boundMutate
    };
}

export default usePatients;